import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import { FC } from 'react';

const LoaderWrapper = styled('div')(({ theme }) => ({
	position: 'fixed',
	top: 0,
	left: 0,
	zIndex: 2001,
	width: '100%',
	'& > * + *': {
		marginTop: theme.spacing(2),
	},
}));

const Loader: FC = () => (
	<LoaderWrapper>
		<LinearProgress color={'primary'} />
	</LoaderWrapper>
);

export default Loader;
